














import { Component, Prop, Vue } from 'vue-property-decorator';
import { Util } from '@/Util';

@Component
export default class PlacesFilter extends Vue {
  get search() {
    return this.$store.getters.filter.search;
  }

  set search(term) {
    this.$store.commit('updateFilterSearch', term);
  }

  get tags() {
    return this.$store.getters.filteredTags;
  }

  get icon() {
    return this.$store.getters.view === 'Map' ? 'list' : 'map-o';
  }

  track() {
    this.$ga.page(Util.getTrackingUrl(this.$store.getters.view.toLowerCase(), this.$store.getters.filter.search));
  }

isTagActive(tag:string):boolean {
    return this.$store.getters.filter.tags.indexOf(tag) >= 0;
  }

  toggleView():void {
    this.$store.commit('toggleView');
  }
}
